export default __webpack_public_path__ + "static/media/ticket.fac80a64.svg";